export default __webpack_public_path__ + "static/media/sticker-4.989825d2.png";